export class ErrorMessages {
  static Generic = 'Something went wrong... please refresh your browser and try again.';
  static ValidationFailed = 'Please fix the errors on the page and try again.';
}